import React from 'react';

const drafts = new Map<symbol, boolean>();
let position = 0;
let previousUrl = '';

export function useDraftProtection(dirty: boolean) {
  const key = React.useRef(Symbol('draft'));
  React.useEffect(() => {
    drafts.set(key.current, dirty);
    return () => { drafts.delete(key.current); };
  }, [dirty]);
  return () => { drafts.delete(key.current); };
}

function canLeave() {
  return ![...drafts.values()].some(Boolean) || window.confirm('You have unsaved changes. Leave and discard them?');
}

export function initializeNavigation() {
  position = window.history.state?.childPosition ?? 0;
  previousUrl = window.location.href;
  window.history.replaceState({ ...window.history.state, childPosition: position }, '', previousUrl);
}

export function acceptBrowserNavigation() {
  const next = window.history.state?.childPosition;
  const previous = new URL(previousUrl);
  const current = new URL(window.location.href);
  const crossesChild = previous.pathname !== current.pathname || previous.searchParams.has('setup') !== current.searchParams.has('setup');
  if (crossesChild && !canLeave()) {
    if (typeof next === 'number' && next !== position) window.history.go(position - next);
    else window.history.replaceState({ childPosition: position }, '', previousUrl);
    return false;
  }
  position = typeof next === 'number' ? next : position;
  previousUrl = window.location.href;
  return true;
}

export function navigate(to: string) {
  const next = new URL(to, window.location.href);
  const current = new URL(window.location.href);
  const crossesContext = next.pathname !== current.pathname || next.searchParams.has('setup') !== current.searchParams.has('setup');
  if (crossesContext && !canLeave()) return;
  position += 1;
  window.history.pushState({ childPosition: position }, '', to);
  previousUrl = window.location.href;
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function protectUnload(event: BeforeUnloadEvent) {
  if ([...drafts.values()].some(Boolean)) {
    event.preventDefault();
    event.returnValue = '';
  }
}
